import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DocumentUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpdateDocuments: () => void;
}

export function DocumentUpdateModal({
  isOpen,
  onClose,
  onUpdateDocuments,
}: DocumentUpdateModalProps) {
  const { t } = useTranslation("onboarding");

  return (
    <Dialog onOpenChange={onClose} open={isOpen}>
      <DialogContent className="sm:max-w-[425px] w-[92%]">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-500/10">
              <AlertCircle className="w-6 h-6 text-red-500" />
            </div>
            <DialogTitle className="text-left">{t("document_update_title")}</DialogTitle>
          </div>
          <DialogDescription className="text-left">
            {t("document_update_description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:gap-2">
          <Button
            className="flex-1"
            type="button"
            variant="secondary"
            onClick={onClose}
          >
            {t("later")}
          </Button>
          <Button className="flex-1" type="submit" onClick={onUpdateDocuments}>
            {t("update_documents")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
